<template>
  <b-col cols="12">
    <b-form @submit="onSubmit">
      <b-form-group
        id="name-input"
        :label="$t('NAME')"
        label-for="name"
      >
        <b-form-input
          id="name"
          v-model="form.name"
          type="text"
          :placeholder="$t('PLACEHOLDER_NAME')"
          :state="formValidation.name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="first-name-input"
        :label="$t('FIRST_NAME')"
        label-for="first_name"
      >
        <b-form-input
          id="first_name"
          v-model="form.first_name"
          type="text"
          :placeholder="$t('PLACEHOLDER_FIRST_NAME')"
          :state="formValidation.first_name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="email-input"
        :label="$t('EMAIL')"
        label-for="email"
      >
        <b-form-input
          id="email"
          v-model="form.email"
          type="text"
          :placeholder="$t('PLACEHOLDER_EMAIL')"
          :state="formValidation.email"
        ></b-form-input>
        <b-form-text id="email-help">{{ $t('EMAIL_INFO') }}</b-form-text>
      </b-form-group>

      <b-form-group
        id="company-input"
        :label="$t('COMPANY')"
        label-for="company"
      >
        <b-form-input
          id="company"
          @blur="checkCompanyByName"
          v-model="form.company"
          type="text"
          :placeholder="$t('PLACEHOLDER_COMPANY')"
          :state="formValidation.company"
        ></b-form-input>
      </b-form-group>
      <div v-if="foundCompanies.length > 0" class="m-3">
        <span class="text-info">Bedoelde je:</span><br />
        <b-list-group>
          <b-list-group-item v-for="company in foundCompanies" :key="company.id" href="#" @click="setCompany(company)">{{ company.name }}</b-list-group-item>
        </b-list-group>
      </div>

      <b-form-group
        id="vat-input"
        :label="$t('VAT')"
        label-for="vat"
      >
        <b-form-input
          id="vat"
          v-model="form.vat"
          type="text"
          @blur="checkCompanyByVat"
          :placeholder="$t('PLACEHOLDER_VAT')"
          :state="formValidation.vat"
        ></b-form-input>
        <b-form-text id="email-help">{{ $t('VAT_INFO') }}</b-form-text>
      </b-form-group>
      <div v-if="foundVatCompanies.length > 0" class="m-3">
        <span class="text-info">Bedoelde je:</span><br />
        <b-list-group>
          <b-list-group-item v-for="company in foundVatCompanies" :key="company.id" href="#" @click="setCompany(company)">{{ company.name }} {{ company.vat }}</b-list-group-item>
        </b-list-group>
      </div>

      <b-form-group
        id="concept-select"
        :label="$t('CHOOSE_CONCEPT')"
        label-for="concept"
      >
        <b-form-select
          id="concept"
          v-model="form.concept"
          :options="concepts"
          :state="formValidation.concept"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        id="course-select"
        :label="$t('CHOOSE_WEBINAR')"
        label-for="course"
      >
        <b-form-select
          id="course"
          v-model="form.course"
          :options="componentCourses"
          :state="formValidation.course"
        ></b-form-select>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox
          id="terms"
          v-model="form.terms"
          name="terms"
          value="1"
          unchecked-value="0"
          :state="formValidation.terms"
        >
          {{ $t('TERMS1') }} <a :href="this.$store.getters.componentData.conditions_url" target="_blank">{{ $t('TERMS_LINK') }}</a> {{ $t('TERMS2') }}
        </b-form-checkbox>
      </b-form-group>
      <transition name="fade">
        <b-row v-if="showError">
          <b-col cols="12">
            <b-alert variant="danger" show>{{ $t('FORM_ERROR') }}</b-alert>
          </b-col>
        </b-row>
      </transition>
      <transition name="fade">
        <b-row v-if="showExistError">
          <b-col cols="12">
            <b-alert variant="danger" show>{{ $t('FORM_EXIST_ERROR') }}</b-alert>
          </b-col>
        </b-row>
      </transition>
      <transition name="fade">
        <b-row v-if="showFullError">
          <b-col cols="12">
            <b-alert variant="danger" show>{{ $t('FORM_FULL_ERROR') }}</b-alert>
          </b-col>
        </b-row>
      </transition>
      <transition name="fade">
        <b-row v-if="showSpinner">
          <b-col cols="12" class="text-center">
            <spin-line :color="this.$store.getters.componentData.css_btn_bg_color" size="80px"></spin-line>
          </b-col>
        </b-row>
      </transition>
      <transition name="fade">
        <b-form-group class="mt-5" v-if="showSubmit">
          <b-button type="submit" variant="primary">{{ $t('BTN_SEND') }}</b-button>
        </b-form-group>
      </transition>
      <transition name="fade">
        <b-row v-if="showSuccess">
          <b-col cols="12">
            <b-alert variant="success" show v-html="(this.$store.getters.language === 'nl') ? this.$store.getters.componentData.success_message_nl : this.$store.getters.componentData.success_message_fr"></b-alert>
          </b-col>
        </b-row>
      </transition>
    </b-form>
  </b-col>
</template>

<script>
import EducamApi from '@/axios/educam-api.instance'
import Mailer from '@/mixins/Mailer'
import { SpinLine } from 'vue-loading-spinner'

export default {
  name: 'CompanyConcept',
  mixins: [Mailer],
  components: {
    SpinLine
  },
  data () {
    return {
      existingCompany: null,
      defaultCourseId: '',
      foundCompanies: [],
      foundVatCompanies: [],
      componentCourses: [{
        value: '',
        text: '----- ' + this.$t('CHOOSE_EDUCATION') + ' -----'
      }],
      concepts: [
        {
          value: '',
          text: '----- ' + this.$t('CHOOSE_CONCEPT') + ' -----'
        }
      ],
      showError: false,
      showSuccess: false,
      showFullError: false,
      showExistError: false,
      showSpinner: false,
      showSubmit: true,
      form: {
        name: '',
        first_name: '',
        email: '',
        terms: false,
        company: '',
        vat: '',
        concept: '',
        course: this.$store.getters.componentData.default_course
      },
      formValidation: {
        name: null,
        first_name: null,
        email: null,
        terms: null,
        course: null,
        company: null,
        vat: null,
        concept: null
      }
    }
  },
  beforeMount () {
    this.$store.getters.componentData.courses.forEach((value, key) => {
      this.componentCourses.push({
        text: value.title,
        value: value.id
      })
    })

    EducamApi.get('/crm/companies?type=1').then(response => {
      response.data.detail._embedded.companies.forEach((value, key) => {
        this.concepts.push({
          value: value.id,
          text: value.name
        })
      })
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    checkCompanyByName () {
      if (this.foundCompanies.length === 0 && this.form.company !== '') {
        EducamApi.get('/crm/companies?name=' + encodeURI(this.form.company)).then(response => {
          if (response.data.detail.total_items > 0) {
            this.foundCompanies = response.data.detail._embedded.companies
          } else {
            this.foundCompanies = []
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    checkCompanyByVat () {
      this.formValidation.vat = null
      if (this.foundVatCompanies.length === 0 && this.form.vat !== '') {
        EducamApi.get('/crm/companies?vat=' + encodeURI(this.form.vat)).then(response => {
          if (response.status === 200) {
            if (response.data.detail.valid !== undefined) {
              if (response.data.detail.valid === true) {
                this.foundVatCompanies.push({
                  name: response.data.detail.name,
                  vat: response.data.detail.countryCode + response.data.detail.vatNumber
                })
              }
            } else {
              this.foundVatCompanies.push(response.data.detail)
            }
          } else {
            this.formValidation.vat = null
            this.foundVatCompanies = []
          }
        }).catch(err => {
          this.formValidation.vat = false
          console.log(err)
        })
      }
    },
    setCompany (company) {
      this.form.company = company.name
      this.form.vat = company.vat
      this.form.concept = (company.parent_company !== null) ? company.parent_company.id : ''
      this.existingCompany = company
      this.foundCompanies = []
      this.foundVatCompanies = []
    },
    onSubmit (event) {
      event.preventDefault()

      this.resetErrors()

      this.formValidation.name = this.form.name !== ''
      this.formValidation.first_name = this.form.first_name !== ''
      this.formValidation.email = this.form.email !== ''
      this.formValidation.course = this.form.course !== ''
      this.formValidation.terms = this.form.terms !== false
      this.formValidation.course = this.form.course !== ''
      this.formValidation.company = this.form.company !== ''
      this.formValidation.concept = this.form.concept !== ''

      if (this.formValidation.vat !== false) {
        this.formValidation.vat = this.form.vat !== ''
      }

      const validationValues = Object.values(this.formValidation)
      if (validationValues.indexOf(false) < 0) {
        this.showSpinner = true
        this.showSubmit = false

        if (this.existingCompany && this.existingCompany.vat === this.form.vat && this.existingCompany.id !== undefined) {
          this.register(this.existingCompany.id)
        } else {
          EducamApi.post('/crm/companies', {
            name: this.form.company,
            vat: this.form.vat,
            companies_id: this.form.concept
          }).then(response => {
            const companyId = response.data.detail.id
            this.register(companyId)
          }).catch(error => {
            console.log(error)
          })
        }
      } else {
        this.showError = true
        this.showSpinner = false
        this.showSubmit = true
      }
    },
    register (companyId) {
      EducamApi.post('/courses/subscriptions', {
        name: this.form.name,
        first_name: this.form.first_name,
        email: this.form.email,
        courses_id: this.form.course,
        language: this.$store.getters.language,
        companies_id: companyId
      }).then(async response => {
        let email
        EducamApi.put('/courses/ilias/assign', {
          uuid: response.data.detail.uuid,
          language: (this.$store.getters.language === 'nl' ? 1 : 2),
          courses_id: this.form.course
        }).then(async response => {
          let chosenCourse
          this.$store.getters.componentData.courses.forEach((course, courseKey) => {
            if (course.id === this.form.course) {
              chosenCourse = course
            }
          })

          email = await this.composeEmail(this.$store.getters.componentData.companies_id, null, [
            {
              needle: 'clientName',
              replacer: this.form.first_name + ' ' + this.form.name
            },
            {
              needle: 'login',
              replacer: response.data.detail.login
            },
            {
              needle: 'password',
              replacer: response.data.detail.password
            }
          ], chosenCourse.subscription_email_id)

          EducamApi.get('/crm/companies/' + this.$store.getters.componentData.companies_id).then(async response => {
            await this.sendMail(this.form.email, this.form.first_name + ' ' + this.form.name, process.env.VUE_APP_EMAIL_FROM, response.data.detail.name, email.subject, email.body)
            this.resetForm()
            this.showSpinner = false
            this.showSuccess = true

            setTimeout(() => {
              this.showSuccess = false
              this.showSubmit = true
            }, 5000)
          }).catch(err => {
            console.log(err)
            this.showSpinner = false
          })
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        if (err.response.data.detail.detail !== undefined && err.response.data.detail.detail === 'Subscription exist') {
          this.showExistError = true
          this.resetForm()
          this.showSpinner = false
          this.showSubmit = true
        }

        if (err.response.data.detail.detail !== undefined && err.response.data.detail.detail === 'Subscription full') {
          this.showFullError = true
          this.resetForm()
          this.showSpinner = false
          this.showSubmit = true
        }
        console.log(err)
      })
    },
    resetErrors (resetAlerts = true, resetVat = false) {
      if (resetAlerts) {
        this.showError = false
        this.showFullError = false
        this.showExistError = false
        this.showSpinner = false
        this.showSubmit = true
      }
      for (const property in this.formValidation) {
        if (property !== 'vat' || (property === 'vat' && resetVat === true)) {
          this.formValidation[property] = null
        }
      }
    },
    resetForm () {
      this.form.name = ''
      this.form.first_name = ''
      this.form.email = ''
      this.form.course = ''
      this.form.terms = false
      this.form.company = ''
      this.form.vat = ''
      this.form.concept = ''
      this.resetErrors(false, true)
    }
  }
}
</script>

<style scoped>
.spinner-inner {
  background-color:#FF0000;
}
</style>
